import { AddToCart } from '@theme/cart-api';
import { CollectionPageState } from './collection-page-state.js';

class MainCollectionGrid extends HTMLElement {
  #addToCart = null;
  #pageState = null;
  #countsListenerAttached = false;

  connectedCallback() {
    if (!this.#addToCart) {
      this.#addToCart = new AddToCart(this);
    }

    if (!this.#pageState) {
      this.#pageState = new CollectionPageState(this);
      this.#pageState.connect();
    }

    if (!this.#countsListenerAttached) {
      document.addEventListener('collection-grid:counts-updated', this.#onCountsUpdated);
      this.#countsListenerAttached = true;
    }
  }

  disconnectedCallback() {
    if (this.#countsListenerAttached) {
      document.removeEventListener('collection-grid:counts-updated', this.#onCountsUpdated);
      this.#countsListenerAttached = false;
    }

    this.#pageState?.disconnect();
    this.#pageState = null;
    this.#addToCart = null;
  }

  #onCountsUpdated = (event) => {
    const collectionGrid = this.closest('.collection-grid');
    const shownEl =
      collectionGrid?.querySelector('[data-toolbar-products-shown]') ??
      document.querySelector('[data-toolbar-products-shown]');
    const totalEl =
      collectionGrid?.querySelector('[data-toolbar-products-total]') ??
      document.querySelector('[data-toolbar-products-total]');
    const mainGrid = document.getElementById('mainGrid');
    const gridHolder = document.getElementById('mainCollectionHolder');

    if (!shownEl || !totalEl) {
      return;
    }

    const shown =
      event?.detail?.loaded ??
      mainGrid?.dataset.productsShown ??
      gridHolder?.querySelectorAll('.collection-grid__product-cell').length ??
      gridHolder?.children.length;

    const total = event?.detail?.total ?? mainGrid?.dataset.productCount;

    if (shown != null && shown !== '') {
      shownEl.textContent = String(shown);
    }

    if (total != null && total !== '') {
      totalEl.textContent = String(total);
    }
  };
}

if (!customElements.get('main-collection-grid')) {
  customElements.define('main-collection-grid', MainCollectionGrid);
}
